import * as e from "react";
import { forwardRef as L } from "react";
const n = L(function(t, C) {
  return /* @__PURE__ */ e.createElement(
    "svg",
    {
      fill: "none",
      ref: C,
      viewBox: "0 0 24 24",
      xmlns: "http://www.w3.org/2000/svg",
      ...t
    },
    /* @__PURE__ */ e.createElement(
      "path",
      {
        clipRule: "evenodd",
        d: "M18.3788 5.62118C19.1329 6.37533 20.3619 6.37533 21.1161 5.62118L24 8.5051L8.50512 24L5.62121 21.1161C6.37535 20.362 6.37535 19.133 5.62121 18.3789C4.86706 17.6247 3.63805 17.6247 2.88391 18.3789L0 15.4949L15.4949 0L18.3788 2.88392C17.6246 3.63807 17.6246 4.86703 18.3788 5.62118ZM11.5426 14.7268C12.0943 15.2785 12.9881 15.2785 13.5397 14.7268C14.3637 13.8959 14.4405 12.3107 14.4475 11.6404C14.4475 10.3695 14.4335 9.56649 14.4335 9.56649C14.4335 9.56649 13.6305 9.55253 12.3596 9.55253C11.6893 9.55253 10.1042 9.62935 9.27321 10.4603C8.72157 11.012 8.72157 11.9057 9.27321 12.4574C9.63632 12.8205 10.146 12.9392 10.6069 12.8275C10.6488 12.8275 10.6907 12.8345 10.7256 12.8694C10.7815 12.9183 10.7885 13.0021 10.7396 13.0439C10.4044 13.3023 9.50366 13.8679 8.5959 13.4559L10.5441 15.4042C10.1321 14.4964 10.6977 13.5956 10.956 13.2604C10.9979 13.2115 11.0817 13.2255 11.1306 13.2744C11.1655 13.3093 11.1795 13.3512 11.1725 13.3931C11.0538 13.854 11.1795 14.3637 11.5426 14.7268ZM12.2968 11.1584L13.4 10.5997L12.8344 11.703L13.7143 12.5759L12.4853 12.3873L11.9267 13.4906L11.7312 12.2686L10.5022 12.0731L11.6124 11.5075L11.4169 10.2855L12.2968 11.1584Z",
        fill: "#fff",
        fillRule: "evenodd"
      }
    )
  );
});
export {
  n as StatusIconFreeBet
};
